import styled, { css } from "styled-components";
import { AddIcon, CheckedIcon, PlayIcon } from "../../../Svg";

export const EditorUpdateActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  border-top: 1px solid #e3e6e8;
`;
export const CancelButtonWrapper = styled.div`
  margin-right: 12px;
`;
export const UploadBoxLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px dashed #1e22ff;
  background: #e9e9ff80;
  width: 100%;
  border-radius: 8px;
  transition: all 0.2s;
  margin: 0;
  padding: 28px 20px;
  cursor: pointer;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  color: #000000;
`;
export const UploadText = styled.span`
  font-weight: 500;
`;
export const UploadBoxCloudIcon = styled.div`
  height: 32px;
  width: 32px;
  margin-bottom: 4px;
`;
export const CheckedWrapper = styled.div`
  position: absolute;
  right: 12px;
  bottom: 12px;
  height: 24px;
  width: 24px;
  border-radius: 100%;
  border: 1.5px solid #e9e9ff;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;
export const RemoveWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 12px;
  height: 24px;
  width: 24px;
  border-radius: 100%;
  border: 1.5px solid #fc7979;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;
export const BuyWrapper = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
  height: 24px;
  width: 24px;
  border-radius: 100%;
  border: 1.5px solid #e9e9ff;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;

export const ShutterstockMark = styled.div`
  position: absolute;
  left: 8px;
  top: 8px;
  height: 15px;
  width: 15px;
  opacity: 0.8;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;

export const ArchiveButton = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
  height: 30px;
  width: 30px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 50;
  filter: drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.5)) drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.5));
`;

export const CreativeWrapper = styled.figure`
  display: inline-block;
  position: relative;
  margin: 0 0 10px 0;
  grid-template-rows: 1fr auto;
  break-inside: avoid;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
  &:hover {
    transform: scale(1.02);
  }
  ${(props) =>
    props.active
      ? `
    ${CheckedWrapper} {
      opacity: 1;
    }
    ${RemoveWrapper} {
      opacity: 1;
    }
    ${BuyWrapper} {
      opacity: 1;
    }
  `
      : `
    ${CheckedWrapper} {
      opacity: 0;
    };
    ${BuyWrapper} {
      opacity: 0;
    };
    ${RemoveWrapper} {
      opacity: 0;
    };
    &:hover {
      ${CheckedWrapper} {
        opacity: 0.3;
      };
      ${RemoveWrapper} {
        opacity: 0.3;
      };
    };
  `}
`;

export const CreativesWrapper = styled.div`
  ${(props) =>
    props.flex
      ? css`
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          ${CreativeWrapper} {
            flex: 0 1 49%;
          }
        `
      : css`
          column-count: 2;
          column-gap: 8px;
          ${props.creativesCount == 2 ? "display: flex;" : null}
        `}
`;

export const CreativeImg = styled.img`
  display: flex;
  grid-row: 1 / -1;
  grid-column: 1;
  width: 100%;
`;
export const CreativeVideoWrapper = styled.div`
  display: flex;
  grid-row: 1 / -1;
  grid-column: 1;
  width: 100%;
`;
export const CreativesText = styled.div`
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  margin-bottom: 6px;
  width: 100%;
`;
export const Checked = styled(CheckedIcon)`
  display: flex;
  width: 20px;
  height: 20px;
`;

export const Add = styled(AddIcon)`
  display: flex;
`;

export const PlayIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
  width: 50px;
  height: 50px;
  transition: all 0.2s;
  ${(props) =>
    props.show
      ? `
    opacity: 0.8;
  `
      : `
    opacity: 0;
  `};
`;

export const UploadPhotoButtonWrapper = styled.div`
  margin-bottom: 20px;
  .upload-btn-wrap {
    background: transparent !important;
    margin: 0;
    padding: 0;
    width: 100%;
    &:hover {
      ${UploadBoxLabel} {
        background: #dfdff5;
      }
    }
  }
`;

export const SearchBarWrapper = styled.div`
  margin-bottom: 24px;
`;

export const LoadingIndicatorWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const CustomPlayIcon = PlayIcon;

export const StockContent = styled.div`
  padding: 16px 0;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ButtonLoadMore = styled.button`
  appearance: none;
  background-color: #1e22ff;
  border-radius: 6px;
  border: none;
  color: white;
  cursor: pointer;
  display: inline-block;
  font-family: "Rubik", sans-serif;
  font-size: 13px;
  font-weight: bold;
  line-height: 1.4;
  padding: 6px 18px;
  text-align: center;
  transform: scale(1);
  transition: transform 0.05s, background-color 0.3s;

  &:hover {
    background: #8066ff;
  }

  &:active {
    transform: scale(0.95);
  }
`;
